import React, { useContext, useMemo } from 'react';

import MoreOptionsCell from '../../Cards/MoreOptionsCell';
import { TableContext } from '../TableContext';

interface ActionRowProps {
  data?: any;
  color?: string;
  width?: any;
  actionFn?: (...arg: any) => Promise<void> | void;
  label?: string;
  icon: React.ReactNode;
  freshTable?: boolean;
  switchingLabel?: string[];
  switchingLabelKey?: string;
  conditionalRenderFn?: (...args: any) => boolean;
}

const ActionRow: React.FC<ActionRowProps> = ({
  data,
  color,
  width,
  actionFn,
  label,
  icon,
  freshTable,
  switchingLabel,
  switchingLabelKey,
  conditionalRenderFn,
}) => {
  const tableContext = useContext(TableContext);

  const computedLabel = useMemo(() => {
    if (label) {
      return label;
    }

    if (switchingLabel?.length !== 0) {
      if (data[switchingLabelKey ?? '']) {
        return switchingLabel && switchingLabel[0];
      } else {
        return switchingLabel && switchingLabel[1];
      }
    }
  }, [label, switchingLabel, switchingLabelKey, data]);

  if (conditionalRenderFn && conditionalRenderFn(data)) {
    return <></>;
  }

  return (
    <MoreOptionsCell
      width={width}
      onClick={(e) => {
        // actionFn && actionFn(data);
        if (actionFn) {
          Promise.resolve(actionFn(data)).finally(() => {
            if (freshTable) {
              return tableContext?.setRefreshTable(!tableContext.refreshTable);
            }
          });
        }
      }}
      icon={icon}
      label={computedLabel ?? ''}
      hasModal
      color={color}
    />
  );
};

export default ActionRow;
